import { Destination } from 'modules/dataSync/types';
import { DESTINATION_COLUMN_GRID } from './HeaderRow.styles';
import { DestinationNameCell, LastModified, LastSyncCell, StatusBadge } from './cells';
import { GridRow } from './BodyRow.styles';

export const BodyRow = ({ destination }: { destination: Destination }) => {
  return (
    <GridRow gridLayout={DESTINATION_COLUMN_GRID}>
      <DestinationNameCell
        // Remove split once connected to the BE
        id={destination.id.split('+')[0]}
        name={destination.name}
        vendor={destination.vendor}
      />
      <StatusBadge status={destination.status} />
      <LastSyncCell lastSync={destination.last_successful_transfer_ended_at} />
      <LastModified
        createdAt={destination.createdAt}
        createdBy={destination.createdBy}
        modifiedAt={destination.modifiedAt}
        modifiedBy={destination.modifiedBy}
      />
    </GridRow>
  );
};
